import { Box } from '@hover/blueprint';
import React, { ReactNode } from 'react';

import { Image } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';

import houseImageAvif from 'assets/img/house-split.avif';
import houseImage from 'assets/img/house-split.png';
import houseImageWebP from 'assets/img/house-split.webp';

interface ContainerProps {
  children: ReactNode;
  image?: ReactNode;
}

const Container = ({ children, image }: ContainerProps) => {
  const t = useTranslate('login');

  return (
    <Box
      alignContent="center"
      alignItems="center"
      display="grid"
      gridGap={{ tablet: 600, desktop: 800 }}
      gridTemplateColumns={{ mobile: '1fr', tablet: '1fr 2fr' }}
      justifyContent="center"
      justifyItems="center"
      padding={600}
      width="100%"
    >
      <Box
        display="grid"
        gridRowGap={400}
        justifyContent="stretch"
        justifyItems="center"
        width="100%"
      >
        {children}
      </Box>
      <Box display={{ base: 'none', tablet: 'block' }}>
        {image || (
          <Image
            alt={t('aRenderedImageOfAHouse')}
            avif={houseImageAvif}
            src={houseImage}
            webp={houseImageWebP}
          />
        )}
      </Box>
    </Box>
  );
};

export { Container };
